export const CONDITIONS_LIST = [
  { value: 'is-equal-to', label: 'Is equal to' },
  { value: 'is-not-equal-to', label: 'Is not equal to' },
  { value: 'contains', label: 'Contains' },
  { value: 'does-not-contain', label: 'Does not contain' },
  { value: 'starts-with', label: 'Starts With' },
  { value: 'ends-with', label: 'Ends With' },
  { value: 'is-null', label: 'Is null' },
  { value: 'is-not-null', label: 'Is not null' },
]
export const PARTIAL_CONDITIONS_LIST = [
  { value: 'is-equal-to', label: 'Is equal to' },
  { value: 'is-not-equal-to', label: 'Is not equal to' },
  { value: 'contains', label: 'Contains' },
  { value: 'does-not-contain', label: 'Does not contain' },
  { value: 'is-null', label: 'Is null' },
  { value: 'is-not-null', label: 'Is not null' },
]
export const NUMBER_CONDITIONS_LIST = [
  { value: 'is-equal-to', label: 'Is equal to' },
  { value: 'is-not-equal-to', label: 'Is not equal to' },
  {
    value: 'is-greater-than-or-equal-to',
    label: 'Is greater than or equal to',
  },
  { value: 'is-greater-than', label: 'Is greater than' },
  { value: 'is-less-than-or-equal-to', label: 'Is less than or equal to' },
  { value: 'is-less-than', label: 'Is less than' },
  { value: 'is-null', label: 'Is null' },
  { value: 'is-not-null', label: 'Is not null' },
  { value: 'between', label: 'Between' },
]
export const REPORT_OPTIONS = [
  { name: 'Monthly', id: 'Monthly' },
  { name: 'Weekly', id: 'Weekly' },
]

export const SCREEN_NAMES = {
  RETAILER_CONNECTOR: 'retailer_connector',
  ADD_LINE_ITEMS: 'add_line_items',
  GENERATE_CREDIT_REPORT: 'generate_credit_report',
  DEDUCTION_CUSTOMER: 'deduction_customer',
  OPEN_DEBIT_MEMO: 'open_debit_memo',
  PAYMENT_DETAILS_VIEW: 'payment_details_view',
  INVOICE_SUMMARY: 'invoice_summary',
  REMITTANCE_SUMMARY: 'remittance_summary',
  NEW_REMITTANCE: 'new_remittance',
  ALL_DOCUMENTS: 'all_documents',
  AR_DOCUMENTS: 'ar_documents',
  PROMOTIONS: 'promotions',
  VALIDATIONS: 'validations',
  AWAITING_APPROVAL: 'awaiting_approval',
  APPROVED_DEDUCTIONS: 'approved_deductions',
  LINK_PROMOTIONS: 'link_promotions',
  PROMOTION_HYPERLINK: 'promotions_hyperlink',
  DISPUTE_DIALOG: 'disputeDialog',
  DISPUTE_DIALOG1: 'disputeDialog1',
  MEMO_CHAT: 'memochat',
  TRACK_MANAGE_DISPUTE: 'track_manage_dispute',
  FILE_ATTACHMENT: 'fileAttachment',
  UPLOAD_ATTACHMENT: 'uploadAttachment',
  NEW_PAYMENTS: 'newPayments',
  SPLIT_SCREEN: 'splitScreen',
  ADD_NEW_PROMOTION: 'addNewPromotion',
  INVOICE_LINE_ITEMS: 'invoice_line_items',
  LINE_ITEMS_SUMMARY: 'line_items_summary',
  MATCH_LINE_ITEMS: 'match_line_items',
  APPROVED_CREDIT_REPORT: 'approved_credit_report',
  ITEMIZATION_DEBIT_MEMO: 'itemazation_debit_memo',
  BULK_PROMOTIONS: 'bulk_promotions',
  MY_DOWNLOADS: 'my_downloads',
}

export const DOCUMENT_TYPE_ID = {
  BackupDocument: 1,
  DisputeDocument: 2,
  RemittancesDocuments: 3,
  Other: 8,
  promotion_documents: 11,
}

export const DOWNLOAD_TABLE_TYPES = {
  INVOICES: 'invoices',
  FILES: 'files',
}

export const ACTIVITY_FIELD_NAMES = {
  DEBIT_MEMO: 'debit_memo',
  DISPUTE_AMOUNT: 'dispute_amount',
  DISPUTE_MEMO: 'dispute_memo',
  DEDUCTION_MEMO: 'deduction_memo',
  SETTLE_AMOUNT: 'settle_amount',
  DEDUCTION_TYPE_ID: 'deduction_type_id',
  GL_CODE: 'gl_code',
  END_RETAILER: 'end_retailer',
  DISPUTE_STATUS: 'dispute_status',
  CUSTOMER_SEGMENT: 'customer_segment',
  PRODUCT_GROUP: 'product_group',
  FEES_TOTAL: 'fees_total',
  PROMOTION_NUMBER: 'promotion_number',
  APPROVER_USER_ID: 'approver_user_id',
  PROCESSOR_USER_ID: 'processor_user_id',
  POSTING_DATE: 'posting_date',
  ORIGINAL_AMOUNT: 'original_amount',
  ERP_BALANCE_AMOUNT: 'erp_balance_amount',
  ERP_LAST_BALANCE_AMOUNT: 'erp_last_balance_amount',
  BASELINE_DATE: 'baseline_date',
  PAYMENT_DUE_DATE: 'payment_due_date',
  ERP_LAST_CLEARING_DATE: 'erp_last_clearing_date',
  TERMS_DAYS: 'terms_days',
  CREDIT_LINE_ITEM: 'credit_line_item',
  TERMS_DISCOUNT: 'terms_discount',
  CARRIER: 'carrier',
  PURCHASE_ORDER: 'purchase_order',
  CUSTOMER_SUB_GROUP: 'customer_sub_group',
  PROMOTION_END_DATE: 'promotion_end_date',
  PROMOTION_START_DATE: 'promotion_start_date',
  INVOICE_DATE: 'invoice_date',
  PROCESSING_STATUS: 'processing_status',
  MESSAGES: 'messages',
  SPLIT_ACTIVITY: 'split_activity',
}

export const PROMOTION_DATE_COLUMNS = [
  'PromotionStartDate',
  'promotion_start_date',
  'PromotionEndDate',
  'promotion_end_date',
]

export const DATE_FORMATS = {
  DATE: 'MM/DD/YYYY',
  TIME: 'h:mm a',
  DATE_TIME: 'MM/DD/YYYY, hh:mm a',
  SHORT_DATE: 'MMM dd',
}

export const DEFAULT_PAGE_SIZE = 100
export const INITIAL_RECORDS_COUNT = 25

export const RELOAD_ACTION = 'reload' as const

export const DROPDOWN_TYPES = {
  APPROVER: 'Approver',
  ATTACHMENTS_TYPES: 'AttachmentsTypes',
  APPROVER_CUSTOM_LIST_FOR_MEMO_CHAT: 'approverCustomListForMemoChat',
  _BRAND: 'brand',
  BRAND: 'Brand',
  CREDIT_LINE_ITEM: 'CreditLineItem',
  FIELDS_MAP: 'FieldsMap',
  RETAILER_DOCUMENTS_TYPES: 'RetailerDocumentTypes',
  RETAILER_CLAIM_TYPES: 'RetailerClaimTypes',
  CUSTOMER: 'Customer',
  CUSTOMER_ID: 'customer_id',
  CUSTOMER_ERP_ID: 'CustomerERPID',
  CUSTOMER_SEGMENT: 'CustomerSegment',
  DEDUCTION_TYPE: 'DeductionType',
  DEDUCTION_TYPE_ID: 'DeductionTypeID',
  DOCUMENT_TYPES: 'DocumentTypes',
  DISPUTE_STATUS_ID: 'DisputeStatusID',
  ITEMIZATION_STATUS: 'ItemizationStatus',
  PROCESSING_STATUS_ID: 'ProcessingStatusID',
  PROCESSOR: 'Processor',
  LEVEL_APPROVER_CUSTOM_LIST: 'levelApproverCustomList',
  APPROVER_LEVEL_2: 'ApproverLevel2',
  APPROVER_LEVEL_3: 'ApproverLevel3',
  REPORT_TYPE: 'reportType',
  PRODUCT_CATEGORY: 'ProductCategory',
  _PRODUCT_CATEGORY: 'product_category',
  PRODUCT_GROUP: 'ProductGroup',
  _PRODUCT_GROUP: 'product_group',
  RETAILER_CODE: 'RetailerCode',
  SPEND_TYPE: 'spend_type',
  _SPEND_TYPE: 'spendType',
  STATUS: 'status',
  PROCESSOR_ID: 'ProcessorID',
}

export const COLUMNS = {
  PROMOTION_NUMBER: 'PromotionNumber',
  END_RETAILER: 'EndRetailer',
  DIVISION_DC_NUM: 'DivisionDcNum',
  PURCHASE_ORDER: 'PurchaseOrder',
  SETTLE_AMOUNT: 'SettleAmount',
  DEBIT_MEMO: 'DebitMemo',
  DEDUCTION_MEMO: 'DeductionMemo',
  CARRIER: 'Carrier',
  INVOICE_DATE: 'InvoiceDate',
  INVOICE_NUMBER: 'InvoiceNumber',
  PROMOTION_START_DATE: 'PromotionStartDate',
  PROMOTION_END_DATE: 'PromotionEndDate',
  PAYMENT_NUMBER: 'PaymentNumber',
  DISPUTE_STATUS_ID: 'DisputeStatusID',
  DEDUCTION_TYPE: 'DeductionType',
  PROCESSING_STATUS_ID: 'ProcessingStatusID',
  PROCESSOR: 'Processor',
  PROCESSOR_ID: 'ProcessorID',
  APPROVER: 'Approver',
  CREDIT_LINE_ITEM: 'CreditLineItem',
  CUSTOMER_SUB_GROUP: 'CustomerSubGroup',
  RETAILER_CODE: 'RetailerCode',
  GL_CODE: 'GLCode',
  STATUS: 'status',
  SPEND_TYPE: 'spendType',
  BRAND: 'brand',
  PRODUCT_GROUP: 'productGroup',
  PRODUCT_CATEGORY: 'productCategory',
  CUSTOMER: 'Customer',
  PLANNED_AMOUNT: 'planned_amount',
  SPEND_AMOUNT: 'spend_amount',
  REMAINING_BALANCE: 'remaining_balance',
  _SPEND_TYPE: 'spend_type',
  _BRAND: 'brand',
  SPLIT_AMOUNT: 'split_amount',
  _PROMOTION_NUMBER: 'promotion_number',
  _CUSTOMER: 'customer',
  DIVISION: 'division',
  _END_RETAILER: 'end_retailer',
  UPC: 'upc',
  CONTRACT_NUMBER: 'contract_number',
  _PROMOTION_START_DATE: 'promotion_start_date',
  _PROMOTION_END_DATE: 'promotion_end_date',
  _PRODUCT_GROUP: 'product_group',
  _PRODUCT_CATEGORY: 'product_category',
  PAYMENT_DATE: 'PaymentDate',
  DISPUTE_DATE: 'DisputeDate',
  APPROVER_LEVEL_2: 'ApproverLevel2',
  APPROVER_LEVEL_3: 'ApproverLevel3',
}

export const COLUMN_TYPES = {
  PLAIN_TEXT: 'PlainText',
  INLINE_TEXT: 'InlineText',
  INLINE_DATE: 'InlineDate',
  DROP_DOWN: 'DropDown',
  NUMBER_TEXT: 'NumberText',
  INLINE_CURRENCY_TEXT: 'InlineCurrencyText',
}

export const APIS = {
  CUSTOMER_SUB_GROUP: 'fetchCustomerSubGroup',
  CREDIT_LINE_ITEMS: 'fetchCreditLineItems',
  CUSTOMERS_LIST: 'fetchCustomersList',
  DISPUTE_STATUS_LIST: 'fetchDisputeStatusList',
  DEDUCTIONS_TYPE_LIST: 'fetchDeductionsTypeList',
  DOCUMENTS_FETCH: 'documents/fetch',
  DOCUMENTS_DOWNLOAD: 'documents/download-file',
  DOCUMENT_TYPES: 'fetchDocumentType',
  FIELDS_MAP: 'fetchFieldIdsMap',
  RETAILER_DOCUMENTS_TYPES: 'RetailerDocumentType',
  PROCESSING_STATUS_LIST: 'fetchProcessingStatusList',
  USERS_LIST: 'fetchUsersList',
  ITEMIZATION_STATUS: 'fetchItemizationStatus',
  RETAILER_CLAIM_TYPES: 'RetailerClaimTypes',
  RETAILER_CONFIGS: 'retailerConfigs',
  SPLIT_REVERSE: 'splitReverse',
  CONFIGURATIONS: 'configurations',
  FETCH_ALL_DOCUMENTS: 'documents/fetchAllDocuments',
  LINE_ITEMS_SUMMARY: 'LineItems/summary',
  JOBS_LIST: 'jobs/list',
}

export const IGNORE_GLOBAL_LOADER_APIS = [
  APIS.CUSTOMER_SUB_GROUP,
  APIS.CREDIT_LINE_ITEMS,
  APIS.CUSTOMERS_LIST,
  APIS.DISPUTE_STATUS_LIST,
  APIS.DEDUCTIONS_TYPE_LIST,
  APIS.DOCUMENTS_FETCH,
  APIS.DOCUMENT_TYPES,
  APIS.FIELDS_MAP,
  APIS.PROCESSING_STATUS_LIST,
  APIS.RETAILER_CLAIM_TYPES,
  APIS.RETAILER_DOCUMENTS_TYPES,
  APIS.USERS_LIST,
  APIS.ITEMIZATION_STATUS,
  APIS.RETAILER_CONFIGS,
  APIS.SPLIT_REVERSE,
  APIS.CONFIGURATIONS,
  APIS.FETCH_ALL_DOCUMENTS,
  APIS.LINE_ITEMS_SUMMARY,
]

export const STRINGS = {
  MEMO_CHAT: 'memoChat',
  SESSION_STORAGE_IS_LOGIN_KEY: 'true',
}

export const CHECKBOX_EVENTS = {
  CHECKED: 'checked', //for single checkbox
  ALL: 'all',
  ALL_WITH_FILTER: 'all-with-filter',
  FILTER_APPLIED: 'filter-applied',
  FILTER_APPLIED_WITHOUT_ALL: 'filter-applied-withoutall',
}

export const BULK_ACTIONS = {
  DEBIT_DOCUMENT: 'debitDocument',
  AUTO_ASSIGN_APPROVER: 'autoAssignApprover',
  ASSIGN_APPROVER: 'assignApprover',
  DEBIT_MEMO: 'debitMemo',
  APPEND_NOTE: 'appendNote',
  REASSIGN_APPROVER: 'reassignApprover',
  DISPUTE: 'dispute',
  PROMOTION: 'promotion',
}

export const BULK_ACTIONS_TEXT = {
  DEBIT_DOCUMENT: 'Debit Document',
  AUTO_ASSIGN_APPROVER: 'Auto Assign Approver',
  DEBIT_MEMO: 'Debit Memo',
  APPEND_NOTE: 'Append Note',
  REASSIGN_APPROVER: 'Reassign Approver',
  DISPUTE: 'Dispute',
}

export const APPROVAL_TYPES = {
  PROCESSOR: 'Processor',
  APPROVER: 'Approver',
}

export const UPDATE_TYPES = {
  REASSIGN_PROCESSOR: 'reassign_processor',
  CREDIT_LINE_ITEM: 'credit_line_item',
  DEDUCTION_TYPE: 'deduction_type',
  RETAILER_CONFIG_ID: 'retailer_config_id',
  PROCESSING_STATUS: 'processing_status',
  REASSIGN_APPROVER: 'reassign_approver',
  APPROVER: 'Approver',
  PROCESSING_STATUS_ID: 'ProcessingStatusID',
}

export const DIALOG_TEXTS = {
  PROCESSOR_UPDATE: 'Processor update',
  DEDUCTION_UPDATE: 'deduction update',
  RETAILER_CODE_UPDATE: 'retailercode update',
}

export const PAYLOAD_TYPES = {
  APPROVER: 'Approver',
  UPLOAD: 'Upload',
  REMITTANCE_UPLOAD: 'RemitanceUpload',
  PROMOTION_UPLOAD: 'PromotionUpload',
}

export const FILE_TYPES_NAMES = {
  [DOCUMENT_TYPE_ID.BackupDocument]: 'Deduction Backup',
  [DOCUMENT_TYPE_ID.DisputeDocument]: 'Dispute Backup',
  [DOCUMENT_TYPE_ID.RemittancesDocuments]: 'Remittances',
  [DOCUMENT_TYPE_ID.Other]: 'Other',
  [DOCUMENT_TYPE_ID.promotion_documents]: 'Promotion Documents',
}

export const TOAST_POSITIONS = {
  TOP_RIGHT: 'toast-top-right',
  TOP_CENTER: 'toast-top-center',
}

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 75, 100],
}

export const PROCESSING_STATUS = {
  OPEN: 'Open',
  AWAITING_APPROVAL: 'Awaiting Approval',
  AWAITING_APPROVAL_LEVEL_1: 'Awaiting Approval-Level 1',
  AWAITING_APPROVAL_LEVEL_2: 'Awaiting Approval-Level 2',
  AWAITING_APPROVAL_LEVEL_3: 'Awaiting Approval-Level 3',
  APPROVED: 'Approved',
  THRESHOLD_CREDIT: 'Threshold Credit',
  CREDIT: 'Credit',
  DISPUTE: 'Dispute',
  SPLIT: 'Split',
  EXISTS_IN_ERP: 'Exists in ERP',
  NETTING_TO_0: 'Netting to 0',
  NOT_APPLICABLE: 'Not Applicable',
}

export const FILTER_CONDITIONS = {
  IS_EQUAL_TO: 'is-equal-to',
  IS_NOT_EQUAL_TO: 'is-not-equal-to',
  CONTAINS: 'contains',
  DOES_NOT_CONTAIN: 'does-not-contain',
  STARTS_WITH: 'starts-with',
  ENDS_WITH: 'ends-with',
  IS_NULL: 'is-null',
  IS_NOT_NULL: 'is-not-null',
  BETWEEN: 'between',
  IS_GREATER_THAN: 'is-greater-than',
  IS_GREATER_THAN_OR_EQUAL_TO: 'is-greater-than-or-equal-to',
  IS_LESS_THAN: 'is-less-than',
  IS_LESS_THAN_OR_EQUAL_TO: 'is-less-than-or-equal-to',
}

export const SCREEN_HEADER_TEXT = {
  RETAILER_CONNECTOR: 'Retailer Connectors',
  DEDUCTION_CUSTOMER: 'Deduction by Customers',
  INVOICE_SUMMARY: 'Invoice Summary Report',
  OPEN_DEBIT_MEMO: 'Open Debit Memos',
  REMITTANCE_SUMMARY: 'Remittance Summary',
  REMITTANCE_DETAILS: 'Remittance Details',
  REMITTANCE_NUMBER: 'Remittance Number',
  NEW_REMITTANCE: 'New Remittance',
  ALL_DOCUMENTS: 'All Documents',
  AR_DOCUMENTS: 'AR Documents',
  VALIDATIONS: 'Validations',
  AWAITING_APPROVAL: 'Approvals',
  PROMOTIONS: 'Promotions',
  PROMOTION_HYPERLINK: 'Promotion Hyperlink',
  APPROVED_DEDUCTIONS: 'Approved Deductions',
  TRACK_MANAGE_DISPUTE: 'Track & Manage Dispute',
  UPLOAD_FILES: 'Upload Files',
  SPLIT_PROMOTIONS: 'Promotions',
  APPEND_NOTE: 'Append Note',
  DISPUTE_DIALOG: 'Dispute',
  DISPUTE: 'Dispute',
  EXPORT_REPORT: 'Export Report',
  UPDATE_DEBIT_DOCUMENT: 'Update Debit Document',
  PROCESSING_STATUSES: 'Processing Statuses',
  ASSIGN_APPROVERS: 'Assign Approvers',
  LINKED_REMITTANCE: 'Linked Remittance',
  SPLIT_INVOICES: 'Split Invoices',
  MATCH_LINE_ITEMS: 'Line Items',
  CREATE_NEW_REMITTANCE: 'Create New Remittance',
  BULK_DOWNLOAD: 'Bulk Download',
  MY_DOWNLOADS: 'My Downloads',
  CREDIT_REPORT: 'Credit Report',
  DASHBOARD: 'Dashboard',
  GENERATE_CREDIT_REPORT: 'Generate Credit Report',
  ITEMIZED_DEBIT_MEMO: 'Itemize Debit Memo',
  ADD_NEW_PROMOTIONS: 'Add New Row(s)',
  TABLE_LAYOUT: 'Table Layout',
  CREATE_NEW_LAYOUT: 'Create New Layout',
  VIEW_DOCUMENTS: 'View Documents',
}

export const DISPUTE_STATUSES = [
  'Paid',
  'Partially Paid',
  'Final Denial',
  'Interim Denial',
  'Invalid Dispute',
]

export const IDENTIFIER = {
  ID: 'id',
  INVOICE_ID: 'InvoiceID',
  PAYMENT_ID: 'PaymentId',
  LINE_ITEM_ID: 'LineItemId',
  DEBIT_MEMO_ID: 'debit_memo_id',
}

export const COMMON_SCREEN_NAMES = [
  'invoice_summary',
  'remittance_summary',
  'new_remittance',
  'ar_documents',
  'validations',
  'awaiting_approval',
  'approved_deductions',
  'track_manage_dispute',
  'invoice_line_items',
]

export const DOCUMENT_STATUS = {
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable',
}

export const DOWNLOAD_STATUSES = {
  SUCCESS: 'Success',
  IN_PROGRESS: 'In_progress',
  FAILED: 'Failed',
  IN_QUEUE: 'In_Queue',
}

export const MEMO_NAVIGATION_TABS = [
  { tab: 'Open', routePath: 'new-payments' },
  { tab: 'Awaiting Approval', routePath: 'validations' },
  { tab: 'Approved', routePath: 'approvals' },
  { tab: 'Threshold Credit', routePath: 'approvals' },
  { tab: 'Credit', routePath: 'trackdisputes' },
  { tab: 'Dispute', routePath: 'trackdisputes' },
  { tab: 'AR-Document', routePath: 'ar-documents' },
]

export const MEMO_CHAT_TAB_ITEMS = {
  DEDUCTION_MEMO: { tab: 'Deduction Memo', routePath: 'trackdisputes' },
  DOCUMENTS: { tab: 'Documents', routePath: 'trackdisputes' },
}

export const MEMO_CHAT_NAVIGATION_TABS = Object.values(MEMO_CHAT_TAB_ITEMS)

export const FIELD_NAMES = {
  UPLOAD_REM_FILE: 'Upload Remittance File',
}
